import React, { useEffect } from 'react'
import BasicCard from '../card/basiccard/BasicCard'
import Heading from '../heading/Heading'
import VerticalSeparator from '../separator/verticalseparator/VerticalSeparator'
import styles from './SavedCardsList.styles'
import { VEC_ICON_NAME } from '../icons/constants'
import CardWTopRightIcon from '../card/CardWTopRightIcon/CardWTopRightIcon'

export default function SavedCardsList({
    cardsList = [],
    setAsDefaultCb = () => {},
    onSelectCb = () => {},
    selectedCard = null,
    isEditable=false
}) {

    useEffect(() => {
        if (!isEditable & !selectedCard) {
            findAndSetSelectedCard();
        }
    }, []);

    const findAndSetSelectedCard = () => {
        for (const eachCard of cardsList) {
            if (eachCard.Selected) {
                onSelectCb(eachCard);
                return;
            }
        }

        if (cardsList.length > 0) {
            onSelectCb(cardsList[0]);
        }
    };

    return (
        <div>
            {cardsList.map((cardObj, idx) =>
                <div style={{...styles.cardBox, ...(!isEditable ? styles.pointer : {})}} onClick={() => !isEditable && onSelectCb(cardObj)}>
                    <CardWTopRightIcon
                        isSelected={selectedCard?.Value === cardObj?.Value}
                        topLeftIcon={ {icon: isEditable ? VEC_ICON_NAME.STAR_ICON : VEC_ICON_NAME.CIRCULAR_CHECKBOX, title: "", selected: selectedCard?.Value === cardObj?.Value} }
                        setDefaultCb={() => setAsDefaultCb(cardObj)}
                        isEditable={isEditable}
                    >
                        {/* Bank name not available. BE will need to attach a bank account to a customer in Stripe*/}
                        <Heading customStyle={styles.bankName}>{cardObj?.name || cardObj?.brand || 'Card Name'}</Heading>
                        <div style={styles.cardInformation}>
                            <span style={styles.cardText}>{cardObj?.Text}</span>
                        </div>
                        <span style={styles.cardText}>{cardObj?.name}</span>
                    </CardWTopRightIcon>
                </div>
            )}
        </div>
    )
}